import React from 'react';
import PropTypes from 'prop-types';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import './DatePicker.scss';

function CustomDatePicker({ values, setFieldValue, errors, touched, name, placeholder, onBlur }) {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        displayStaticWrapperAs="desktop"
        inputVariant="standard"
        value={values[name]}
        InputProps={{ disableUnderline: true }}
        onChange={(value) => setFieldValue(name, value)}
        className={errors[name] && touched[name] && 'error'}
        renderInput={(params) => (
          <div className="custom-picker">
            <TextField
              {...params}
              variant="standard"
              inputProps={{
                ...params.inputProps,
                placeholder,
                onBlur,
              }}
            />
          </div>
        )}
      />
    </LocalizationProvider>
  );
}

CustomDatePicker.propTypes = {
  placeholder: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errors: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  touched: PropTypes.any.isRequired,
  onBlur: PropTypes.func.isRequired,
};

export default CustomDatePicker;
